module.exports = __webpack_public_path__ + "static/media/icon_network_1.18708d3e.svg";